import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class ItiModalDialog extends Vue {
  @Prop({ default: '800px' }) public maxWidth!: string | number;

  @Prop({ default: false }) public visible = false;

  public internalShowDialog: boolean = false;

  @Watch('visible') public onChanged(val: boolean, oldVal: boolean) {
    this.internalShowDialog = val;
  }

  public show() {
    this.internalShowDialog = true;
  }

  public hide() {
    this.internalShowDialog = false;
  }
}
